import { render, staticRenderFns } from "./InappBrowserWarningDialog.vue?vue&type=template&id=70016db3&scoped=true"
import script from "./InappBrowserWarningDialog.vue?vue&type=script&lang=js"
export * from "./InappBrowserWarningDialog.vue?vue&type=script&lang=js"
import style0 from "./InappBrowserWarningDialog.vue?vue&type=style&index=0&id=70016db3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../production-parity-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70016db3",
  null
  
)

export default component.exports